<template>
    <div class='conversation-list'>
        <div class="project-list card">
            <header class="card-header">
                <div class=" card-header-title">
                    <h2 class="is-size-4">Samtaler</h2>
                </div>
            </header>

            <div class="card-content">
                <template v-for="conversation in conversations">
                    <conversation-list-item :conversation="conversation" :key="conversation.id" />
                </template>

                <loader v-if="isLoading" text="Indlæser.." style="min-height: 300px" />

                <div v-else-if="!conversations.length">
                    <p>Du har endnu ingen samtaler.</p>
                </div>
            </div>
        </div>

    </div>
</template>

<style lang="scss" scoped>
    @import '../../../global/styles/variables';

</style>

<script>
    import ConversationListItem from '@/taskflex/conversations/components/ConversationListItem';
    import ConversationService from '@/taskflex/conversations/services/ConversationService';
    import Loader from '@/global/components/Loader';

    export default {
        data() {
            return {
                conversations: [],
                isLoading: false,
                page: 1,
                limit: 999,
                total: null,
            };
        },

        mounted() {
            this.loadConversations();
        },

        methods: {
            loadConversations() {
                this.isLoading = true;

                const options = {
                    includes: ['project', 'addressee', 'sender', 'latestMessage.sender'],
                    sort: [
                        {
                            key: 'updated_at',
                            direction: 'desc',
                        },
                    ],

                    limit: this.limit,
                    page: this.page,

                    filter_groups: [
                        {
                            filters: [
                                {
                                    key: 'hasProjects',
                                    operator: 'eq',
                                    value: false,
                                },
                            ],
                        },
                    ],
                };

                ConversationService.findAll(options, ({ data: { rows, total } }) => {
                    this.conversations = rows;
                    this.total = total;

                    this.isLoading = false;
                });
            },
        },

        components: {
            ConversationListItem,
            Loader,
        },
    };
</script>



// WEBPACK FOOTER //
// src/taskflex/conversations/components/OverviewList.vue